import {VariantConfigT} from '@/lib/types/colors.types';

export const infoConfig: VariantConfigT = {
  basic: {
    icon: 'info',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'info',
    active: 'info',
  },
  outline: {
    icon: 'info',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'info',
    iconHover: 'info',
    iconActive: 'info',
    hover: 'info',
    active: 'info',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
